<template>

<div>

    <b>Vigor</b> {{vigor}} % -

    <span v-if="vigor <= 25">
                                    Muy floja
                                </span>
    <span v-else-if="vigor > 25 && vigor < 50">
                                    Normal
                                </span>
    <span v-else-if="vigor >= 50 && vigor < 75">
                                    Fuerte
                                </span>
    <span v-else-if="vigor >= 75">
                                    Muy Fuerte
                                </span>

</div>

</template>

<script>

export default {
  name: 'vigor',
  props: ['vigor'],
};
</script>
